import {
  AttachMoneyOutlined,
  BarChartOutlined,
  Dashboard,
  HomeOutlined,
  HubOutlined,
  InsertDriveFileOutlined,
  MonitorHeart,
  Phonelink,
  ReceiptOutlined,
  RequestQuoteOutlined,
  RouterOutlined,
  SecurityOutlined,
  SettingsOutlined,
  SupportAgentOutlined,
  TipsAndUpdatesOutlined,
} from "@mui/icons-material";

// Ícones por rota (usado no card de permissão do portal)
export const iconMapCliente = {
  "/resumo": <HomeOutlined />,
  "/home": <BarChartOutlined />,
  "/home/overview": <Dashboard />,
  "/home/saude": <MonitorHeart />,
  "/home/disponibilidade": <Phonelink />,
  "/home/firewall": <SecurityOutlined />,
  "/home/onu": <RouterOutlined />,
  "/home/rede": <HubOutlined />,
  "/tickets": <SupportAgentOutlined />,
  "/financeiro": <AttachMoneyOutlined />,
  "/financeiro/faturas": <RequestQuoteOutlined />,
  "/financeiro/nfs": <ReceiptOutlined />,
  "/financeiro/contratos": <ReceiptOutlined />,
  "/relatorios": <InsertDriveFileOutlined />,
  "/sugestoes": <TipsAndUpdatesOutlined />,
  "/configuracoes": <SettingsOutlined />,
};

// Ícones por nome de página (usado na árvore de seleção de acessos).
// Complementa o mapa padrão de components/MenuPermissionTree.
export const iconMapMenuCliente = {
  Faturas: <RequestQuoteOutlined />,
  NFs: <ReceiptOutlined />,
  Sugestões: <TipsAndUpdatesOutlined />,
  Configurações: <SettingsOutlined />,
};

// Endpoints das permissões do portal do cliente
export const endpointsCliente = {
  allRoutes: "/cliente/find/allRoutes",
  create: "/cliente/create/permissao",
  edit: "/cliente/edit/permissao",
  delete: "/cliente/delete/permissao",
};
